import { SystemPermissionDef } from '@juvare/contact-management/backend/features/permissions/shared';

export const dependenciesVersionsPermissionsMap = {
    'view-versions': {
        group: 'System',
        label: 'View Used Libraries Versions',
    },
} as const satisfies SystemPermissionDef;
